import { sleep } from 'root/apps/label/utils/async';

export const resolveOnTimeout = async <T>(
  promise: Promise<T>,
  timeout: number
): Promise<T | void> => {
  await Promise.race([sleep(timeout), promise]);
};
